<template>
    <div>
        <b-modal id="deleteDepartment"
                 content-class="argus-glass-dialog department-dialog"
                 scrollable
                 header-close-label="Закрыть"
                 @hide="guardHide"
                 @hidden="resetDialog"
                 @show="loadDepartment"
                 title="Удаление отдела"
                 no-close-on-backdrop
        >
            <p v-if="loading" role="status">Загружаем отдел…</p>
            <fieldset v-show="!loading && !loadFailed" :disabled="saving" class="department-form">
                <p class="my-4">
                    Вы действительно хотите удалить отдел
                    <span class="text-danger">{{ name }}</span>
                    из системы?
                </p>
            </fieldset>
            <template #modal-footer="{cancel}">
                <div class="department-dialog-footer">
                    <div v-if="actionError" class="department-dialog-error" role="alert">{{ actionError }}</div>
                    <div class="department-dialog-actions">
                        <b-button variant="outline-secondary" :disabled="saving" @click="cancel()">Отмена</b-button>
                        <b-button v-if="loadFailed" variant="primary" @click="loadDepartment">Повторить загрузку</b-button>
                        <b-button v-else variant="danger" :disabled="saving || loading" @click="submit">
                            {{ saving ? 'Подождите…' : 'Удалить' }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import departmentDialog from "../departmentDialog";
    export default {
        mixins: [departmentDialog],
        computed: {
            selectedDepartmentId() {
                return this.$store.state.selectedDepartmentId;
            }
        },
        data() {
            return {
                name: null
            }
        },
        methods: {
            clearForm() {
                this.name = null;
            },
            setDepartment({name}) {
                this.name = name;
            },
            submit() {
                if (this.saving || this.loading || this.loadFailed) return;
                this.actionError = '';
                return this.saveDepartment('deleteDepartment', this.selectedDepartmentId, 'deleteDepartment');
            }
        },
        name: "DeleteDepartment"
    }
</script>
